
// This is a magic number that means tiles like status block show a
// nice number of blocks before being overflowed at different grid sizes etc.
export const rowHeight = 125;

export const maxColumns = 15;